// extracted by mini-css-extract-plugin
export default {"container":"PixInfo_container__QF3nS","label":"PixInfo_label__YkgqK","input":"PixInfo_input__XNeTu"};